const l = [
  "beacon-anchor-navigation",
  "beacon-area-chart",
  "beacon-bar-chart",
  "beacon-bio-card",
  "beacon-article-tile",
  "beacon-button",
  "beacon-byline",
  "beacon-carousel",
  "beacon-chart-tooltip",
  "beacon-chart-tooltip-data",
  "beacon-checkbox",
  "beacon-collection-tile",
  "beacon-contact-tile",
  "beacon-country",
  "beacon-country-selector",
  "beacon-data-list",
  "beacon-date-picker",
  "beacon-donut-chart",
  "beacon-dropdown",
  "beacon-error",
  "beacon-error-message-summary",
  "beacon-footer",
  "beacon-gauge-chart",
  "beacon-hero",
  "beacon-icon-button",
  "beacon-id-card",
  "beacon-input-button-field",
  "beacon-input-field",
  "beacon-key-facts",
  "beacon-legacy-collection-tile",
  "beacon-legend",
  "beacon-legend-item",
  "beacon-line-chart",
  "beacon-modal",
  "beacon-navigation",
  "beacon-navigation-button",
  "beacon-navigation-expanded",
  "beacon-navigation-footer",
  "beacon-navigation-popover",
  "beacon-navigation-toolbelt",
  "beacon-popover",
  "beacon-promo-tile",
  "beacon-quote-block",
  "beacon-radio-button",
  "beacon-radio-group",
  "beacon-region-selector",
  "beacon-scatter-chart",
  "beacon-social-link",
  "beacon-social-link-container",
  "beacon-stepper",
  "beacon-tab",
  "beacon-tab-panel",
  "beacon-table",
  "beacon-table-caption",
  "beacon-table-header",
  "beacon-table-record",
  "beacon-table-stub",
  "beacon-tabs",
  "beacon-text-area",
  "beacon-toggle-button-field",
  "beacon-tooltip",
  "beacon-value-prop",
  "beacon-video",
  "beacon-video-tag",
  "beacon-video-transcript"
], x = {
  allComponents: l
}, j = (t) => t.replace(/[A-Z]+(?![a-z])|[A-Z]/g, (e, n) => (n ? "-" : "") + e.toLowerCase()), g = (t) => /^([a-z](?![\d])|[\d](?![a-z]))+(-?([a-z](?![\d])|[\d](?![a-z])))*$|^$/.test(t);
function h(t) {
  return `${t}`.toLowerCase().replace(new RegExp(/[-_]+/, "g"), " ").replace(new RegExp(/[^\w\s]/, "g"), "").replace(new RegExp(/\s+(.)(\w*)/, "g"), (e, n, a) => `${n.toUpperCase() + a}`).replace(new RegExp(/\w/), (e) => e.toUpperCase());
}
const f = typeof process == "object" && process && process.env && process.env.UNIT_TESTING_ENV;
function v(t) {
  switch (t) {
    case "./__temp-separated/beacon-anchor-navigation/index.js":
      return import("./register-chunks/index-DZYwO_oB.js");
    case "./__temp-separated/beacon-area-chart/index.js":
      return import("./register-chunks/index-DwVLqJcQ.js");
    case "./__temp-separated/beacon-article-tile/index.js":
      return import("./register-chunks/index-DImoZX6-.js");
    case "./__temp-separated/beacon-async-append.d/index.js":
      return import("./register-chunks/index-DKrTW6i7.js");
    case "./__temp-separated/beacon-async-directive.d/index.js":
      return import("./register-chunks/index-CMQGoHCs.js");
    case "./__temp-separated/beacon-async-replace.d/index.js":
      return import("./register-chunks/index-vJutlYqr.js");
    case "./__temp-separated/beacon-bar-chart/index.js":
      return import("./register-chunks/index-BQzOqDQi.js");
    case "./__temp-separated/beacon-bio-card/index.js":
      return import("./register-chunks/index-DQ_9FCWw.js");
    case "./__temp-separated/beacon-button/index.js":
      return import("./register-chunks/index-CCOEN8jp.js");
    case "./__temp-separated/beacon-byline/index.js":
      return import("./register-chunks/index-DMYdH6x_.js");
    case "./__temp-separated/beacon-cache.d/index.js":
      return import("./register-chunks/index-Bryup_DX.js");
    case "./__temp-separated/beacon-carousel/index.js":
      return import("./register-chunks/index-DpzQomwZ.js");
    case "./__temp-separated/beacon-chart-tooltip/index.js":
      return import("./register-chunks/index-XNmOMYOG.js");
    case "./__temp-separated/beacon-chart-tooltip-data/index.js":
      return import("./register-chunks/index-lxzBh0Va.js");
    case "./__temp-separated/beacon-checkbox/index.js":
      return import("./register-chunks/index-DO5XxawA.js");
    case "./__temp-separated/beacon-choose.d/index.js":
      return import("./register-chunks/index-CnEXUajW.js");
    case "./__temp-separated/beacon-class-map.d/index.js":
      return import("./register-chunks/index-BTPPuDSQ.js");
    case "./__temp-separated/beacon-collection-tile/index.js":
      return import("./register-chunks/index-B2YUhJG_.js");
    case "./__temp-separated/beacon-contact-tile/index.js":
      return import("./register-chunks/index-CgTdOrmA.js");
    case "./__temp-separated/beacon-country/index.js":
      return import("./register-chunks/index-NhDcJ58g.js");
    case "./__temp-separated/beacon-country-selector/index.js":
      return import("./register-chunks/index-C4td0xoT.js");
    case "./__temp-separated/beacon-custom-element.d/index.js":
      return import("./register-chunks/index-DbWwwmsA.js");
    case "./__temp-separated/beacon-data-list/index.js":
      return import("./register-chunks/index-D6CRgDk4.js");
    case "./__temp-separated/beacon-date-picker/index.js":
      return import("./register-chunks/index-C51cv-ZC.js");
    case "./__temp-separated/beacon-decorators.d/index.js":
      return import("./register-chunks/index-GrFpLtOX.js");
    case "./__temp-separated/beacon-directive-helpers.d/index.js":
      return import("./register-chunks/index-GS9HVUhU.js");
    case "./__temp-separated/beacon-directive.d/index.js":
      return import("./register-chunks/index-DUPC5men.js");
    case "./__temp-separated/beacon-donut-chart/index.js":
      return import("./register-chunks/index-Z0WjMdUF.js");
    case "./__temp-separated/beacon-dropdown/index.js":
      return import("./register-chunks/index-C6ceg2wc.js");
    case "./__temp-separated/beacon-error/index.js":
      return import("./register-chunks/index-CixIeOcY.js");
    case "./__temp-separated/beacon-error-message-summary/index.js":
      return import("./register-chunks/index-CROrr4dz.js");
    case "./__temp-separated/beacon-event-options.d/index.js":
      return import("./register-chunks/index-DPRe0aaE.js");
    case "./__temp-separated/beacon-footer/index.js":
      return import("./register-chunks/index-C8WiG-Na.js");
    case "./__temp-separated/beacon-gauge-chart/index.js":
      return import("./register-chunks/index-BmMlGgEM.js");
    case "./__temp-separated/beacon-guard.d/index.js":
      return import("./register-chunks/index-Bq3IA9wI.js");
    case "./__temp-separated/beacon-hero/index.js":
      return import("./register-chunks/index-CF1P-CTj.js");
    case "./__temp-separated/beacon-html.d/index.js":
      return import("./register-chunks/index-BqflxSah.js");
    case "./__temp-separated/beacon-icon-button/index.js":
      return import("./register-chunks/index-BQXo7AfV.js");
    case "./__temp-separated/beacon-id-card/index.js":
      return import("./register-chunks/index-CgEo4tCF.js");
    case "./__temp-separated/beacon-if-defined.d/index.js":
      return import("./register-chunks/index-CZNVDa_h.js");
    case "./__temp-separated/beacon-index.all.d/index.js":
      return import("./register-chunks/index-2EqeFNVQ.js");
    case "./__temp-separated/beacon-index.d/index.js":
      return import("./register-chunks/index-CYVhMk7R.js");
    case "./__temp-separated/beacon-input-button-field/index.js":
      return import("./register-chunks/index-BGPYe5kB.js");
    case "./__temp-separated/beacon-input-field/index.js":
      return import("./register-chunks/index-DMjgDyOb.js");
    case "./__temp-separated/beacon-join.d/index.js":
      return import("./register-chunks/index-DEobFpnq.js");
    case "./__temp-separated/beacon-key-facts/index.js":
      return import("./register-chunks/index-CzIT5wyr.js");
    case "./__temp-separated/beacon-keyed.d/index.js":
      return import("./register-chunks/index-CEllwla6.js");
    case "./__temp-separated/beacon-legacy-collection-tile/index.js":
      return import("./register-chunks/index-Zo5otUIB.js");
    case "./__temp-separated/beacon-legend/index.js":
      return import("./register-chunks/index-tfItJZfY.js");
    case "./__temp-separated/beacon-legend-item/index.js":
      return import("./register-chunks/index-DvxdeP1d.js");
    case "./__temp-separated/beacon-line-chart/index.js":
      return import("./register-chunks/index-DuXvvQEj.js");
    case "./__temp-separated/beacon-live.d/index.js":
      return import("./register-chunks/index-CXqf6FM0.js");
    case "./__temp-separated/beacon-map.d/index.js":
      return import("./register-chunks/index-pVy2w11a.js");
    case "./__temp-separated/beacon-modal/index.js":
      return import("./register-chunks/index-CkQgIrGb.js").then((e) => e.index);
    case "./__temp-separated/beacon-navigation/index.js":
      return import("./register-chunks/index-CEC0kE8V.js").then((e) => e.index);
    case "./__temp-separated/beacon-navigation-button/index.js":
      return import("./register-chunks/index-CEC0kE8V.js").then((e) => e.index$1);
    case "./__temp-separated/beacon-navigation-expanded/index.js":
      return import("./register-chunks/index-CEC0kE8V.js").then((e) => e.index$2);
    case "./__temp-separated/beacon-navigation-footer/index.js":
      return import("./register-chunks/index-BufbpV33.js");
    case "./__temp-separated/beacon-navigation-popover/index.js":
      return import("./register-chunks/index-CEC0kE8V.js").then((e) => e.index$3);
    case "./__temp-separated/beacon-navigation-toolbelt/index.js":
      return import("./register-chunks/index-CEC0kE8V.js").then((e) => e.index$4);
    case "./__temp-separated/beacon-polyfill-support.d/index.js":
      return import("./register-chunks/index-C26s4wmt.js");
    case "./__temp-separated/beacon-popover/index.js":
      return import("./register-chunks/index-CASdepYk.js");
    case "./__temp-separated/beacon-promo-tile/index.js":
      return import("./register-chunks/index-CXiQxd_R.js");
    case "./__temp-separated/beacon-property.d/index.js":
      return import("./register-chunks/index-Ba2D8NOp.js");
    case "./__temp-separated/beacon-query-all.d/index.js":
      return import("./register-chunks/index-CYExkqVo.js");
    case "./__temp-separated/beacon-query-assigned-elements.d/index.js":
      return import("./register-chunks/index-Dv3E82ME.js");
    case "./__temp-separated/beacon-query-assigned-nodes.d/index.js":
      return import("./register-chunks/index-DtLnbphQ.js");
    case "./__temp-separated/beacon-query-async.d/index.js":
      return import("./register-chunks/index-9lW9Ler5.js");
    case "./__temp-separated/beacon-query.d/index.js":
      return import("./register-chunks/index-JXWggS5z.js");
    case "./__temp-separated/beacon-quote-block/index.js":
      return import("./register-chunks/index-CAlmcuc3.js");
    case "./__temp-separated/beacon-radio-button/index.js":
      return import("./register-chunks/index-BTgw0XDh.js");
    case "./__temp-separated/beacon-radio-group/index.js":
      return import("./register-chunks/index-Dj4KMUWq.js");
    case "./__temp-separated/beacon-range.d/index.js":
      return import("./register-chunks/index-BjUa5J8D.js");
    case "./__temp-separated/beacon-ref.d/index.js":
      return import("./register-chunks/index-D6tAgeVX.js");
    case "./__temp-separated/beacon-region-selector/index.js":
      return import("./register-chunks/index-BAr0qr51.js");
    case "./__temp-separated/beacon-repeat.d/index.js":
      return import("./register-chunks/index-V98zUapQ.js");
    case "./__temp-separated/beacon-scatter-chart/index.js":
      return import("./register-chunks/index-CBNAZ7ur.js");
    case "./__temp-separated/beacon-social-link/index.js":
      return import("./register-chunks/index-ebx7-_Wm.js");
    case "./__temp-separated/beacon-social-link-container/index.js":
      return import("./register-chunks/index-CXAra5gT.js");
    case "./__temp-separated/beacon-state.d/index.js":
      return import("./register-chunks/index-3_KllEcQ.js");
    case "./__temp-separated/beacon-static-html.d/index.js":
      return import("./register-chunks/index-QWNUvlPp.js");
    case "./__temp-separated/beacon-stepper/index.js":
      return import("./register-chunks/index-kZ1qFxLX.js");
    case "./__temp-separated/beacon-style-map.d/index.js":
      return import("./register-chunks/index-ZA2t6PJL.js");
    case "./__temp-separated/beacon-tab/index.js":
      return import("./register-chunks/index-HQCudQFQ.js");
    case "./__temp-separated/beacon-tab-panel/index.js":
      return import("./register-chunks/index-iIFXkuBg.js");
    case "./__temp-separated/beacon-table/index.js":
      return import("./register-chunks/index-DG5i-i12.js");
    case "./__temp-separated/beacon-table-caption/index.js":
      return import("./register-chunks/index--hv2hD5q.js");
    case "./__temp-separated/beacon-table-header/index.js":
      return import("./register-chunks/index-ocbEMqrb.js").then((e) => e.index);
    case "./__temp-separated/beacon-table-record/index.js":
      return import("./register-chunks/index-CsDvhEud.js").then((e) => e.index);
    case "./__temp-separated/beacon-table-stub/index.js":
      return import("./register-chunks/index-CXV_aO9d.js").then((e) => e.index);
    case "./__temp-separated/beacon-tabs/index.js":
      return import("./register-chunks/index-DRnylQq5.js");
    case "./__temp-separated/beacon-template-content.d/index.js":
      return import("./register-chunks/index-CmNe708F.js");
    case "./__temp-separated/beacon-text-area/index.js":
      return import("./register-chunks/index-DkBg-s6M.js");
    case "./__temp-separated/beacon-toggle-button-field/index.js":
      return import("./register-chunks/index-Yl4-AOjH.js");
    case "./__temp-separated/beacon-tooltip/index.js":
      return import("./register-chunks/index-BI1-Ksyi.js");
    case "./__temp-separated/beacon-unsafe-html.d/index.js":
      return import("./register-chunks/index-Dtb3gRbV.js");
    case "./__temp-separated/beacon-unsafe-svg.d/index.js":
      return import("./register-chunks/index-CvnhN9vC.js");
    case "./__temp-separated/beacon-until.d/index.js":
      return import("./register-chunks/index-ClcFagzl.js");
    case "./__temp-separated/beacon-value-prop/index.js":
      return import("./register-chunks/index-Di-qMy0X.js");
    case "./__temp-separated/beacon-video/index.js":
      return import("./register-chunks/index-BenY55PG.js");
    case "./__temp-separated/beacon-video-tag/index.js":
      return import("./register-chunks/index-BkjXRSsS.js");
    case "./__temp-separated/beacon-video-transcript/index.js":
      return import("./register-chunks/index-BtiFjFnk.js");
    case "./__temp-separated/beacon-when.d/index.js":
      return import("./register-chunks/index-BOt94Cl3.js");
    default:
      return new Promise(function(e, n) {
        (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
          n.bind(null, new Error("Unknown variable dynamic import: " + t))
        );
      });
  }
}
const d = async (t = "", e = document.body) => {
  const n = t ? t + "-beacon-" : "beacon-", a = e instanceof Element ? e.tagName.toLowerCase() : "", o = a == null ? void 0 : a.startsWith(n), c = [...e.querySelectorAll(":not(:defined)")].map((s) => s.tagName.toLowerCase()).filter((s) => s.startsWith(n));
  o && !customElements.get(a) && c.push(a);
  const r = [...new Set(c)].map((s) => t ? s.split(`${t}-`)[1] : s);
  r.length && await C(t, r);
}, y = (t) => {
  const e = j(t);
  return g(t) || console.warn(
    `Beacon Warning: '${t}' is not a valid Beacon component tag name. Class name casing will be deprecated soon. Update to tag name "${e}".`
  ), e;
}, w = (t) => {
  const e = y(t);
  return {
    tagName: e,
    className: h(e)
  };
}, m = async (t, e, n) => new Promise((a, o) => {
  var c;
  if (typeof e == "string") {
    const { tagName: r, className: s } = w(e), b = t ? `${t}-${r}` : r;
    customElements.get(b) ? a(customElements.get(b)) : v(`./__temp-separated/${r}/index.js`).then((p) => {
      var _;
      const i = p[`${s}`];
      i.registerComponent(t), (_ = i.nestedComponents) != null && _.length && Promise.all(
        i.nestedComponents.map(
          (u) => m(t, u, n)
        )
      ), a(i);
    }).catch(() => {
      const p = `Beacon Registration Error: Unable to import ${e}`;
      n ? o(new Error(p)) : a(p);
    });
  } else if (e.registerComponent) {
    const r = e;
    r.registerComponent(t), (c = r.nestedComponents) != null && c.length && Promise.all(
      r.nestedComponents.map(
        (s) => m(t, s, n)
      )
    ), a(r);
  }
}), C = async (t = "", e = [], n = !f) => {
  const a = e.length ? e : x.allComponents;
  await Promise.all(
    a.map(
      (o) => m(t, o, n)
    )
  );
}, $ = async (t = "") => {
  const e = new MutationObserver(async (n) => {
    for (const { addedNodes: a } of n)
      for (const o of a)
        o instanceof Element && await d(t, o);
  });
  return E(e), await d(t), k(t), e.observe(document.documentElement, { subtree: !0, childList: !0 }), e;
}, E = (t) => {
  const e = Element.prototype.attachShadow;
  Element.prototype.attachShadow = function(n) {
    const a = e.call(this, n);
    return this.tagName.includes("BEACON") || t.observe(a, { subtree: !0, childList: !0 }), a;
  };
}, k = (t, e = document) => {
  Array.from(e.querySelectorAll(":not([beacon-tag-name])")).filter(
    (o) => o.tagName.includes("-") && !o.tagName.includes("BEACON")
  ).forEach((o) => {
    o.shadowRoot && o instanceof HTMLElement && d(t, o.shadowRoot);
  });
};
export {
  $ as autoLoadBeaconComponents,
  k as discoverComponentsInShadowDOM,
  w as getComponentIdentifiers,
  y as getComponentTagName,
  m as importAndRegisterComponent,
  E as polyfillAttachShadowWithObserver,
  C as registerBeaconComponents
};
